//= require ./compare_gl

const WHITE = [255, 255, 255, 255];

window.CompareVersions = {
  _pdfViewer: null,
  _active: false,
  _navigationBar: null,
  _documentVersionId: null,
  _documentVersionsLinks: null,
  _scrollIndependently: false,
  _pageRendering: false,
  _currentPageTops: [],
  _previousPageTops: [],
  _comparePageTops: [],
  _currPage: null,
  _prevPage: null,
  _renderedPages: [],
  _pageChanged: false,
  _pageContainerWidth: null,
  _pageContainerHeight: null,
  _rotationDegrees: 0,

  _documents: {
    current: {
      id: null,
      page: null,
      link: null,
      navigationElement: null,
      maxPages: null,
      containerId: 'left',
      renderedPages: [],
      extraTopCanvasesCount: 0,
      extraBottomCanvasesCount: 0
    },
    previous: {
      id: null,
      page: null,
      link: null,
      navigationElement: null,
      maxPages: null,
      containerId: 'right',
      renderedPages: [],
      extraTopCanvasesCount: 0,
      extraBottomCanvasesCount: 0
    }
  },

  _redish(val) { return [255, val, val, 255]; },
  _bluish(val) { return [val, val, 255, 255]; },
  _isWhite(arr) { return this._compareArrays(arr, WHITE); },

  _compareArrays(arr1, arr2) {
    if (arr1.length !== arr2.length) { return false; }
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) { return false; }
    }
    return true;
  },

  _renderCompareCanvases(currPage, prevPage) {
    this._pageRendering = true;
    currPage = this._documents.current.page;
    prevPage = this._documents.previous.page;

    if (!_.contains(this._documents.current.renderedPages, this._documents.current.page)) { this._documents.current.renderedPages.push(currPage); }
    if (!_.contains(this._documents.previous.renderedPages, this._documents.previous.page)) { this._documents.previous.renderedPages.push(prevPage); }

    const callback = (oldCanvasSelector, newCanvasSelector) => {
      if (!oldCanvasSelector) { oldCanvasSelector = `old-canvas-${currPage}`; }
      if (!newCanvasSelector) { newCanvasSelector = `new-canvas-${prevPage}`; }

      this._addExtraMarginForPagesWithDifferentHeights();

      const pageNum = _.max([currPage, prevPage]);
      this._loadCompareOutput(oldCanvasSelector, newCanvasSelector, `compare-canvas-${pageNum}`);
      this._pdfViewer._printOverlayCanvas(this._documents.current.page, '5px', $(`#pdf-container > #compare-canvases > #overlay > compare-page-data-${pageNum}`));
      this._pdfViewer._printOverlayCanvas(this._documents.current.page, '5px', $(`#pdf-container > #compare-canvases > #side-by-side > #left > old-page-data-${pageNum}`));

      this._reindexTops();
      this._jumpToCurrentPage();
      this._pdfViewer.endLoading();

      this._pageChanged = false;
      return this._pageRendering = false;
    };

    const loadSecondDocument = () => {
      if (this._isExtraTopPage(this._documents.previous) || this._isExtraBottomPage(this._documents.previous)) {
        return callback(`old-canvas-${currPage}`, `old-canvas-${currPage}`);
      } else {
        return this._fillCanvasFromPdf(this._documents.previous, { selector: `new-canvas-${prevPage}`, callback });
      }
    };

    if (this._isExtraTopPage(this._documents.current) || this._isExtraBottomPage(this._documents.current)) {
      this._fillCanvasFromPdf(this._documents.previous, { selector: `new-canvas-${prevPage}`, callback, oldCanvasSelector: `new-canvas-${prevPage}` });
    } else {
      this._fillCanvasFromPdf(this._documents.current, { selector: `old-canvas-${currPage}`, callback: loadSecondDocument });
    }

    $('#side-by-side > #right').on('scroll', _.bind(event => this._handleRightScroll(event)));
    $('#side-by-side > #left').on('scroll', _.bind(event => this._handleLeftScroll(event)));
    $('#compare-canvases').on('scroll', _.bind(event => this._handleCompareScroll(event)));
  },

  _isExtraTopPage(doc) {
    return (doc.page <= 0) && (Math.abs(doc.page) <= doc.extraTopCanvasesCount);
  },

  _isExtraBottomPage(doc) {
    return (doc.page > doc.maxPages) && (doc.page <= (doc.extraBottomCanvasesCount + doc.maxPages));
  },

  _jumpToCurrentPage() {
    if (this._documents.current.page > this._documents.previous.page) {
      return this._scrollToPage(this._documents.current, this._documents.current.page);
    } else {
      return this._scrollToPage(this._documents.previous, this._documents.previous.page);
    }
  },

  _getBitMap(canvas) {
    const { width } = canvas;
    const { height } = canvas;
    const ctx = canvas.getContext('2d');
    return ctx.getImageData(0, 0, width, height).data;
  },

  _colourBits(arr1, arr2) {
    const arr1White = this._isWhite(arr1);
    const arr2White = this._isWhite(arr2);

    if (arr1White) {
      if (arr2White) { return WHITE; } else { return this._bluish(arr2[0]); }
    } else {
      if (arr2White) { return this._redish(arr1[0]); } else { return arr1; }
    }
  },

  _calculateIntInCanvas(canvas, x, y) {
    const { width } = canvas;
    const { height } = canvas;
    if ((x >= width) || (y >= height)) { return false; }
    return ((y * width) + x) * 4;
  },

  _loadCompareOutput(fromCanvas, toCanvas, outputCanvas) {
    fromCanvas = document.getElementById(fromCanvas);
    toCanvas = document.getElementById(toCanvas);
    outputCanvas = document.getElementById(outputCanvas);

    if (outputCanvas.getContext('webgl')) {
      return CompareGl.render(outputCanvas, fromCanvas, toCanvas);
    } else {
      const fromMap = this._getBitMap(fromCanvas);
      const toMap = this._getBitMap(toCanvas);
      const sameSize = ((fromCanvas.height === toCanvas.height) && (fromCanvas.width === toCanvas.width));

      const maxX = Math.max(fromCanvas.width, toCanvas.width);
      const maxY = Math.max(fromCanvas.height, toCanvas.height);
      const newMap = [];

      for (let y = 0; y < maxY; y++) {
        for (let x = 0; x < maxX; x++) {
          const i1 = this._calculateIntInCanvas(fromCanvas, x, y);
          const i2 = sameSize ? i1 : this._calculateIntInCanvas(toCanvas, x, y);

          const fromSlice = i1 ? fromMap.slice(i1, i1 + 4) : WHITE;
          const toSlice = i2 ? toMap.slice(i2, i2 + 4) : WHITE;
          const bit = this._colourBits(fromSlice, toSlice);
          newMap.push(...bit);
        }
      }

      const data = {
        map: Uint8ClampedArray.from(newMap),
        width: maxX,
        height: maxY
      };
      return this._setBitMap(outputCanvas, data);
    }
  },

  _setBitMap(canvas, data) {
    canvas.parentElement.setAttribute('height', data['height'] + 10);
    canvas.parentElement.setAttribute('width', data['width']);
    $(canvas).parent('.page').css({ height: data['height'] + 10, width: data['width'] });

    canvas.width = data['width'];
    canvas.height = data['height'];
    const ctx = canvas.getContext('2d');
    return ctx.putImageData(new ImageData(data['map'], data['width'], data['height']), 0, 0);
  },

  _fillCanvasFromPdf(doc, options) {
    if (options == null) { options = {}; }
    const loadFunc = page => {
      const canvas = document.getElementById(options['selector']) || document.createElement('canvas');
      const scale = this._pdfViewer._currentScale;
      const rotation = this._pdfViewer._rotationDegrees;

      const callback = options['callback'] || false;
      const oldCanvasSelector = options['oldCanvasSelector'] || null;

      const viewport = page.getViewport(scale, rotation);
      const context = canvas.getContext('2d');

      this._pdfViewer._pageHeight = (canvas.height = viewport.height);
      this._pdfViewer._pageWidth = (canvas.width = viewport.width);

      const renderContext = {
        canvasContext: context,
        viewport
      };

      this._resizeCanvasPageContainer(canvas, viewport);

      return page.render(renderContext).then(function() {
        if (callback) { return callback(oldCanvasSelector); }
      });
    };

    const loadPage = pdf => {
      return pdf.getPage(doc.page).then(loadFunc);
    };

    if ($(`#compare-canvases > #side-by-side > #${doc.containerId}`).find('.page').length > 0) {
      return loadPage(this._findDocumentVersion(doc.id).pdf);
    } else {
      return PDFJS.getDocument(doc.link).then(pdf => {
        this._setDocumentVersionPdf(doc.id, pdf);
        this._setMaxPage(doc, pdf.pdfInfo.numPages);
        pdf.getPage(1).then(page => {
          const viewport = page.getViewport(this._pdfViewer._currentScale, this._pdfViewer._rotationDegrees);

          if (!this._isSecondDocument(doc)) {
            this._pageContainerWidth = viewport.width;
            this._pageContainerHeight = viewport.height;
          }

          _.each(_.range(1, doc.maxPages + 1), number => {
            return this._createAndAppendCanvas(doc, number, this._pageContainerWidth, this._pageContainerHeight);
          });

          if (this._isSecondDocument(doc)) {
            return this._createAndAppendExtraCanvases(this._pageContainerWidth, this._pageContainerHeight);
          }
        });

        return loadPage(pdf);
      });
    }
  },

  _resizeCanvasPageContainer(canvas, viewport) {
    canvas.parentElement.setAttribute('height', viewport.height + 10);
    canvas.parentElement.setAttribute('width', viewport.width);
    return $(canvas).parent('.page').css({ height: viewport.height + 10, width: viewport.width });
  },

  _addExtraMarginForPagesWithDifferentHeights() {
    const pageNumber = _.max([this._documents.current.page,  this._documents.previous.page]);
    const spaceBetweenPages = 20;
    const cpage = $('#compare-canvases #side-by-side > #left').find(".page")[pageNumber - 1];
    const ppage = $('#compare-canvases #side-by-side > #right').find(".page")[pageNumber - 1];

    const cHeight = $(cpage).height();
    const pHeight = $(ppage).height();
    let newHeight = 0;

    if ($(cpage).hasClass('extra')) {
      newHeight = pHeight + spaceBetweenPages;
    } else if ($(ppage).hasClass('extra')) {
      newHeight = cHeight + spaceBetweenPages;
    } else {
      newHeight = _.max([cHeight, pHeight]) + spaceBetweenPages;
    }

    ppage.setAttribute('height', newHeight);
    $(ppage).css({ height: newHeight });
    cpage.setAttribute('height', newHeight);
    return $(cpage).css({ height: newHeight });
  },

  _isSecondDocument(doc) {
    return doc.containerId === 'right';
  },

  _setDivContainer(id, idPrefix, height, width, containerSelector, classes, prepend) {
    if (classes == null) { classes = ''; }
    if (prepend == null) { prepend = false; }
    const el = document.createElement('div');
    el.setAttribute('id', `${idPrefix}-page-data-${id}`);
    el.setAttribute('position', 'relative');
    el.setAttribute('data-page', id);
    el.setAttribute('height', height + 10);
    el.setAttribute('width', width);
    el.setAttribute('page-rendered', false);
    el.style.height = `${height + 10}px`;
    el.style.border = '10px solid transparent';
    el.className += `page ${classes}`;
    const el2 = document.createElement('div');
    el2.className += 'page-container';
    $(el2).append(el);

    if (prepend) {
      $(containerSelector).prepend(el2);
    } else {
      $(containerSelector).append(el2);
    }

    el2.setAttribute('height', this._pdfViewer._pageHeight);
    el2.setAttribute('width', this._pdfViewer._pageWidth);
    return el;
  },

  _createAndAppendExtraCanvases(height, width) {
    const currPage = this._documents.current.page;
    const prevPage = this._documents.previous.page;

    const currMaxPages = this._documents.current.maxPages;
    const prevMaxPages = this._documents.previous.maxPages;

    const extraTopCanvases = currPage - prevPage;
    const extraBottomCanvases = (currMaxPages - currPage) - (prevMaxPages - prevPage);

    this._documents.current.extraTopCanvasesCount = extraTopCanvases < 0 ? Math.abs(extraTopCanvases) : 0;
    this._documents.previous.extraTopCanvasesCount = extraTopCanvases > 0 ? extraTopCanvases : 0;
    this._documents.current.extraBottomCanvasesCount = extraBottomCanvases < 0 ? Math.abs(extraBottomCanvases) : 0;
    this._documents.previous.extraBottomCanvasesCount = extraBottomCanvases > 0 ? extraBottomCanvases : 0;

    if (this._documents.current.extraTopCanvasesCount > 0) {
      _.each(_.range(1, this._documents.current.extraTopCanvasesCount + 1), id => {
        const idPrefix = 'old-top-extra';
        const extraCanvas = this._createCanvas(`${idPrefix}-canvas-${id}`, height, width, 1200, false);
        const extraDiv = this._setDivContainer(id, idPrefix, height, width, '#pdf-container > #compare-canvases > #side-by-side > #left', 'extra extra-top', true);
        return $(extraDiv).append(extraCanvas);
      });
    } else if (this._documents.previous.extraTopCanvasesCount > 0) {
      _.each(_.range(1, this._documents.previous.extraTopCanvasesCount + 1), id => {
        const idPrefix = 'new-top-extra';
        const extraCanvas = this._createCanvas(`${idPrefix}-canvas-${id}`, height, width, 1200, false);
        const extraDiv = this._setDivContainer(id, idPrefix, height, width, '#pdf-container > #compare-canvases > #side-by-side > #right', 'extra extra-top', true);
        return $(extraDiv).append(extraCanvas);
      });
    }

    if (this._documents.current.extraBottomCanvasesCount > 0) {
      _.each(_.range(1, this._documents.current.extraBottomCanvasesCount + 1), id => {
        const idPrefix = 'old-bottom-extra';
        const extraCanvas = this._createCanvas(`${idPrefix}-canvas-${id}`, height, width, 1200, false);
        const extraDiv = this._setDivContainer(id, idPrefix, height, width, '#pdf-container > #compare-canvases > #side-by-side > #left', 'extra extra-bottom');
        return $(extraDiv).append(extraCanvas);
      });
    } else if (this._documents.previous.extraBottomCanvasesCount > 0) {
      _.each(_.range(1, this._documents.previous.extraBottomCanvasesCount + 1), id => {
        const idPrefix = 'new-bottom-extra';
        const extraCanvas = this._createCanvas(`${idPrefix}-canvas-${id}`, height, width, 1000, false);
        const extraDiv = this._setDivContainer(id, idPrefix, height, width, '#pdf-container > #compare-canvases > #side-by-side > #right', 'extra extra-bottom');
        return $(extraDiv).append(extraCanvas);
      });
    }

    const leftPagesCount = $('#compare-canvases #side-by-side > #left').find('.page').length;
    const rightPagesCount = $('#compare-canvases #side-by-side > #right').find('.page').length;
    const pagesCount = _.max([leftPagesCount, rightPagesCount]);

    return _.each(_.range(1, pagesCount + 1), id => {
      const idPrefix = 'compare';
      if ($(`#${idPrefix}-page-data-${id}`).length === 0) {
        const extraCanvas = this._createCanvas(`${idPrefix}-canvas-${id}`, height, width,  1000, false);
        const extraDiv = this._setDivContainer(id, idPrefix, height, width, '#pdf-container > #compare-canvases > #overlay');
        return $(extraDiv).append(extraCanvas);
      }
    });
  },

  _createAndAppendCanvas(doc, id, height, width) {
    let canvas, divContainer, idPrefix;
    if (doc.containerId === 'left') {
      idPrefix = 'old';
      canvas = this._createCanvas(`${idPrefix}-canvas-${id}`, height, width, 1200, false);
      divContainer = this._setDivContainer(id, idPrefix, height, width, '#pdf-container > #compare-canvases > #side-by-side > #left');
      return $(divContainer).append(canvas);
    } else if (doc.containerId === 'right') {
      idPrefix = 'new';
      canvas = this._createCanvas(`${idPrefix}-canvas-${id}`, height, width, 1000, false);
      divContainer = this._setDivContainer(id, idPrefix, height, width, '#pdf-container > #compare-canvases > #side-by-side > #right');
      return $(divContainer).append(canvas);
    }
  },

  _findDocumentVersion(id) {
    return _.find(this._documentVersionsLinks, { id });
  },

  _setDocumentVersionPdf(id, pdf) {
    return this._findDocumentVersion(id).pdf = pdf;
  },

  _setMaxPage(doc, maxPages) {
    doc.maxPages = maxPages;
    doc.navigationElement.find('#page_count').html(maxPages);
    return doc.navigationElement.find('.page-numbers').toggleClass('disabled', maxPages === 1);
  },

  _createCanvas(id, height, width, zIndex, center) {
    const canvas = document.createElement('canvas');
    canvas.setAttribute('id', id);
    canvas.setAttribute('height', height + 10);
    canvas.setAttribute('width', width);
    canvas.setAttribute('z-index', zIndex);
    if (center) { canvas.style.position = 'absolute'; }
    return canvas;
  },

  _resetRenderedPages() {
    this._documents.current.renderedPages = [];
    return this._documents.previous.renderedPages = [];
  },

  _destroyCanvases() {
    const rootElement = $('#compare-canvases');
    rootElement.find('#overlay').children('canvas').remove();
    rootElement.find('#left').children('canvas').remove();
    rootElement.find('#right').children('canvas').remove();
    rootElement.find('.tool-tip-container').empty();
    return this._resetRenderedPages();
  },

  _destroyDivContainers() {
    const rootElement = $('#compare-canvases');
    rootElement.find('#overlay').children('div.page-container').remove();
    rootElement.find('#left').children('div.page-container').remove();
    return rootElement.find('#right').children('div.page-container').remove();
  },

  _loadComparsion() {
    this._pdfViewer.startLoading();
    this._documents.previous.link = this._findLink(this._documents.previous.id);
    return this._renderCompareCanvases();
  },

  _findLink(id) {
    return _.find(CompareVersions._documentVersionsLinks, {id}).link;
  },

  _showNavigationAction(currentVersion) {
    this._active = !this._active;
    $("#show-nav").toggleClass('active', this._active);
    $('#navigation-bar button:not(#show-nav, #scale-up, #zoom-in, #zoom-out, #rotate, #rotate-left, #scale-down, #fit-width, #fit-page, #full-screen, #print, #pan, #toggleScrolling, #apply, #cancel)').toggleClass('disabled', this._active);
    this._documents.previous.page = (this._documents.current.page = this._pdfViewer._currentPage);
    this._documents.previous.navigationElement.find('#page_number').val(this._documents.previous.page);

    this._documents.current.id = parseInt(currentVersion);
    this._documents.previous.id = parseInt($('#previous_id').data('id'));
    this._documents.current.link = this._findLink(this._documents.current.id);
    this._documents.previous.link = this._findLink(this._documents.previous.id);

    if (this._active) {
      this._loadComparsion();
    } else {
      this._pdfViewer._disableNavButtons();
      this._pdfViewer.showCanvases();
      this._destroyCanvases();
      this._destroyDivContainers();
      this._pdfViewer.reloadCurrentPage();
      this._pdfViewer.endLoading();
    }

    $('#pdf-container > #canvases-container').toggleClass('hidden', this._active);
    $('#pdf-container > #navigation-bar').find('#main-page-numbers').toggleClass('disabled', this._active);
    $('#pdf-container > #compare-canvases').toggleClass('hidden', !this._active);
    return $('#navigation-bar').toggleClass('expanded', this._active);
  },

  _isValidPageNumber(doc, pageNumber) {
    return this._pdfViewer.isNumber(pageNumber) && (pageNumber > 0) && (pageNumber <= doc.maxPages);
  },

  _setPageNumber(doc, pageNumber) {
    const newValue = this._isValidPageNumber(doc, pageNumber) ? pageNumber : 1;
    doc.page = newValue;
    return doc.navigationElement.find('#page_number').val(newValue);
  },

  _changePage(doc, newValue) {
    this._setPageNumber(doc, newValue);
    return this._changePageOrVersion();
  },

  _changePageOrVersion() {
    this._pageChanged = true;
    if (!this._isValidPageNumber(this._documents.current, this._documents.current.page)) { this._setPageNumber(this._documents.current, 1); }
    if (!this._isValidPageNumber(this._documents.previous, this._documents.previous.page)) { this._setPageNumber(this._documents.previous, 1); }
    this._destroyCanvases();
    this._destroyDivContainers();
    return this._loadComparsion();
  },

  _changeModeAction(event) {
    if (event.target.text.trim() === I18n.t('v4.document_versions.overlay')) {
      this._navigationBar.find('#type-select').text(I18n.t('v4.document_versions.overlay'));
      $('#compare-canvases > #side-by-side').addClass('hidden');
      $('#compare-canvases > #overlay').removeClass('hidden');
      $('#toggleScrolling').hide();
    } else {
      this._navigationBar.find('#type-select').text(I18n.t('v4.document_versions.side_by_side'));
      $('#compare-canvases > #side-by-side').removeClass('hidden');
      $('#compare-canvases > #overlay').addClass('hidden');
      $('#toggleScrolling').show();
    }

    this._reindexTops();
    return this._jumpToCurrentPage();
  },

  _prevNextNavigation(doc, moveForward) {
    const current = doc.page;
    const newValue = moveForward ? current + 1 : current - 1;
    return this._changePage(doc, newValue);
  },

  _toggleScrollIndependently() {
    this._scrollIndependently = !this._scrollIndependently;
    $('#toggleScrolling').toggleClass('active', this._scrollIndependently);
    $('#toggleScrolling').toggleClass('clear', !this._scrollIndependently);
    const text = this._scrollIndependently ? I18n.t('v4.document_versions.tooltips.scroll_sync') : I18n.t('v4.document_versions.tooltips.scroll_independent');
    return Foundation.libs.tooltip.getTip($('#toggleScrolling')).html(text);
  },

  _alreadyRendered() {
    return _.contains(this._documents.current.renderedPages, this._documents.current.page) && _.contains(this._documents.previous.renderedPages, this._documents.previous.page);
  },

  _queuePageRendering() {
    if (!this._pageRendering && !this._alreadyRendered()) {
      this._pdfViewer.startLoading();
      return this._renderCompareCanvases();
    }
  },

  _reindexTops() {
    this._currentPageTops = [];
    this._previousPageTops = [];
    this._comparePageTops = [];

    let elements = $('#compare-canvases #side-by-side > #left').find('.page');
    _.each(elements, page => this._currentPageTops.push(page.offsetTop));

    elements = $('#compare-canvases #side-by-side > #right').find('.page');
    _.each(elements, page => this._previousPageTops.push(page.offsetTop));

    elements = $('#compare-canvases #overlay').find('.page');
    return _.each(elements, page => this._comparePageTops.push(page.offsetTop));
  },

   _scrollToPage(doc, page) {
    if ($('#compare-canvases #overlay').is(':visible')) {
      $('#compare-canvases')[0].scrollTop = $('#compare-canvases #overlay').find(`#compare-page-data-${page}`)[0].offsetTop;
    }
    if ($("#compare-canvases > #side-by-side").is(':visible')) {
      return $(`#compare-canvases > #side-by-side > #${doc.containerId}`)[0].scrollTop = $(`#compare-canvases > #side-by-side > #${doc.containerId}`).find(".page")[page - 1].offsetTop;
    }
  },

  _updateDocumentsPageNumber(page) {
    const cpage = $('#compare-canvases #side-by-side > #left').find(".page")[page - 1];
    const ppage = $('#compare-canvases #side-by-side > #right').find(".page")[page - 1];

    const currDisplayPage = $(cpage).hasClass('extra') ? '-' : $(cpage).data('page');
    const prevDisplayPage = $(ppage).hasClass('extra') ? '-' : $(ppage).data('page');

    if (cpage) {
      this._documents.current.navigationElement.find('#page_number').val(currDisplayPage);

      if ($(cpage).hasClass('extra-top')) {
        this._documents.current.page = -parseInt($(cpage).data('page'));
      } else if ($(cpage).hasClass('extra-bottom')) {
        this._documents.current.page = this._documents.current.maxPages + parseInt($(cpage).data('page'));
      } else {
        this._documents.current.page = parseInt($(cpage).data('page'));
      }
    }

    if (ppage) {
      this._documents.previous.navigationElement.find('#page_number').val(prevDisplayPage);

      if ($(ppage).hasClass('extra-top')) {
        return this._documents.previous.page = -parseInt($(ppage).data('page'));
      } else if ($(ppage).hasClass('extra-bottom')) {
        return this._documents.previous.page = this._documents.previous.maxPages + parseInt($(ppage).data('page'));
      } else {
        return this._documents.previous.page = parseInt($(ppage).data('page'));
      }
    }
  },

  _handleCompareScroll(event) {
    if ($('#compare-canvases #overlay').is(':visible')) {
      const top = $(event.target).scrollTop();
      let page = _.findIndex(this._comparePageTops, num => num > top);
      page = page === (-1) ? this._comparePageTops.length : page;
      if ((page !== this._documents.current.page) || (page !== this._documents.previous.page)) {
        this._updateDocumentsPageNumber(page);
        return this._queuePageRendering();
      }
    }
  },

  _handleLeftScroll(event) {
    const top = $(event.target).scrollTop();
    let page = _.findIndex(this._currentPageTops, num => num > top);
    page = page === (-1) ? this._documents.current.maxPages + this._documents.current.extraBottomCanvasesCount + this._documents.current.extraTopCanvasesCount : page;
    if (!this._scrollIndependently) {
      $('#pdf-container > #compare-canvases > #side-by-side > #right').scrollLeft(event.target.scrollLeft);
      $('#pdf-container > #compare-canvases > #side-by-side > #right').scrollTop(event.target.scrollTop);
    }

    if (page !== this._documents.current.page) {
      this._updateDocumentsPageNumber(page);
      return this._queuePageRendering();
    }
  },

  _handleRightScroll(event) {
    const top = $(event.target).scrollTop();
    let page = _.findIndex(this._previousPageTops, num => num > top);
    page = page === (-1) ? this._documents.previous.maxPages + this._documents.previous.extraBottomCanvasesCount + this._documents.previous.extraTopCanvasesCount : page;

    if (!this._scrollIndependently) {
      $('#pdf-container > #compare-canvases > #side-by-side > #left').scrollLeft(event.target.scrollLeft);
      $('#pdf-container > #compare-canvases > #side-by-side > #left').scrollTop(event.target.scrollTop);
    }

    if (page !== this._documents.previous.page) {
      this._updateDocumentsPageNumber(page);
      return this._queuePageRendering();
    }
  },

  setupCompareNavigation(currentVersion, links) {
    const _this = this;

    this._pdfViewer = PdfViewer;
    this._documentVersionsLinks = links;
    this._navigationBar = $('#compare-nav');
    this._documents.previous.navigationElement = this._navigationBar.find('#prev-version');
    this._documents.current.navigationElement = this._navigationBar.find('#current-version');

    $('#previous_id').selectize({
      plugins: ['remove_button'],
      maxItems: 1,
      render: {
        item(item, escape) {
          return `<div class='item' id='selected_previous_version_text'>
            ${escape(item.text)}
          </div>`;
        },
        option(item, escape) {
          return `<div class='option' data-version='${item.version}'>
            ${escape(item.text)}
          </div>`;
        }
      },
      onChange(value) {
        if (_.isEmpty(value)) { return; }
        const newVersionId = parseInt(value);
        const currentVersionId = $('#previous_id').data('id');
        if (newVersionId !== currentVersionId) {
          $('#previous_id').data('id', newVersionId);
          _this._documents.previous.id = newVersionId;
          _this._documents.previous.page = 1;
          $(_this._documents.previous.navigationElement).find('#page_number').val(1);
          return _this._changePageOrVersion();
        }
      }
    });

    $('#current_to_id').selectize({
      plugins: ['remove_button'],
      maxItems: 1, 
      render: {
        item(item, escape) {
          return `<div class='item' id='selected_current_version_text'>
            ${escape(item.text)}
          </div>`;
        },
        option(item, escape) {
          return `<div class='option' data-version='${item.version}'>
            ${escape(item.text)}
          </div>`;
        }
      },
      onChange(value) {
        if (_.isEmpty(value)) { return; }
        const newVersionId = parseInt(value);
        const currentVersionId = $('#current_to_id').data('id');
        if (newVersionId !== currentVersionId) {
          $('#current_to_id').data('id', newVersionId);
          _this._documents.current.id = newVersionId;
          _this._documents.current.link = _this._findLink(newVersionId);
          _this._documents.current.page = 1;
          $(_this._documents.current.navigationElement).find('#page_number').val(1);
          return _this._changePageOrVersion();
        }
      }
    });

    $(document).on('click', '#show-nav', this._showNavigationAction.bind(this, currentVersion));
    this._documentVersionId = currentVersion;

    this._navigationBar.on('click', '.changeMode', this._changeModeAction.bind(this));
    this._navigationBar.on('click', '#toggleScrolling', this._toggleScrollIndependently.bind(this));

    this._documents.previous.navigationElement.on('focus', '#page_number', e => { return this._tempPageValue = e.target.value; });
    this._documents.current.navigationElement.on('focus', '#page_number', e => { return this._tempPageValue = e.target.value; });

    this._documents.previous.navigationElement.on('change', '#page_number', e => this._changePage(this._documents.previous, parseInt(e.target.value)));
    this._documents.current.navigationElement.on('change', '#page_number', e => this._changePage(this._documents.current, parseInt(e.target.value)));

    this._documents.previous.navigationElement.on('click', '#compare-prev', e => this._prevNextNavigation(this._documents.previous, false));
    this._documents.previous.navigationElement.on('click', '#compare-next', e => this._prevNextNavigation(this._documents.previous, true));

    this._documents.current.navigationElement.on('click', '#compare-prev', e => this._prevNextNavigation(this._documents.current, false));
    this._documents.current.navigationElement.on('click', '#compare-next', e => this._prevNextNavigation(this._documents.current, true));

    return $(document).on('reloadCompare', this._changePageOrVersion.bind(this));
  }
};
